<div class="overlay" (click)="onClose()"> 
    <div class="content text-center m-b-20">
        <!-- progress-bar -->
        <div class="d-flex-center m-l-20 m-r-20">
            <div class="progress-bar-container">
                <div class="progress-bar" [style.width]="progress + '%'"></div>
            </div>
        </div>
        <div *ngIf="assignedStickerType == 1" class="font-22 text-center font-bold m-t-20 p-l-10 p-r-10">¡Genial! Te ganaste un sticker.</div>
        <div *ngIf="assignedStickerType == 2" class="font-22 text-center font-bold m-t-20 p-l-10 p-r-10">¡Felicidades! Desbloqueaste un sticker y te ganaste un premio.</div>
        <div *ngIf="assignedStickerType == 3" class="font-22 text-center font-bold m-t-20 p-l-10 p-r-10">¡Wow! Desbloqueaste un sticker y te ganaste una raspadita.</div>
        <div class="d-flex-center">
            <img *ngIf="assignedStickerType == 1" src="assets/images/assigned-sticker.gif" style="max-width: 250px;">
            <img *ngIf="assignedStickerType == 2" src="assets/images/assigned-sticker-prize.gif" style="max-width: 250px;">
            <img *ngIf="assignedStickerType == 3" src="assets/images/assigned-sticker-scratch.gif" style="max-width: 250px;">
        </div> 
        <div *ngIf="assignedStickerType == 2 && assignedCoupon">
            <div class="font-16 font-bold">{{assignedCoupon.name}}</div> 
            <div class="img-coupon-container">
                <div class="img-coupon d-flex-center">
                    <img src="assets/images/GiviBITFormat3.png" style="height: 100%;">
                    <img [src]="assignedCoupon.url" class="img-coupon-givi">
                </div>
            </div>
        </div>
        <div class="font-h5 m-t-20" style="text-decoration: underline;">VOLVER</div>
        <audio #audioPlayer src="assets/audios/successredeemedsound2.mp3" autoplay></audio>
    </div>
</div>
